import React, { useEffect, useState } from 'react';
import ReactPlayer, { type ReactPlayerProps } from 'react-player';
import { useContentPlayer } from './hooks/ContentPlayerProvider';
import { useVideoPlayerRef } from './hooks/useVideoPlayerRef';
import { cn } from './imports';
import VideoPreview from '@components/shared/VideoPreview';
import { ImFileVideo } from 'react-icons/im';

interface VideoPlayerProps extends ReactPlayerProps {
  url: string;
  className?: string;
  renderVideo?: boolean;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, pip = false, renderVideo, playing = true, controls = false, muted = false, loop = false, volume = 1, className, ...props }) => {
  const { setMusicVolume, hasInteracted } = useContentPlayer()
  const [isLoading, setIsLoading] = useState(renderVideo)
  const [_muted, setMuted] = useState(!hasInteracted)
  const { loading } = useContentPlayer()
  const { playerRef: ref, onVideoEndedRef } = useVideoPlayerRef();

  function unmute() {
    setMuted(false)
  }

  useEffect(() => {
    if (hasInteracted) unmute()
  }, [hasInteracted])

  useEffect(() => {
    if (muted) setMusicVolume(1)
    else setMusicVolume(0)
  }, [muted])

  return <div
    onClick={unmute}
    className={cn("w-full h-full z-0 bg-black", className)}
  >
    <div
      className={cn('relative h-full w-full', renderVideo && 'pointer-events-none')}
    >
      {isLoading && loading}
      {
        !renderVideo ? <VideoPreview videoUrl={url}>
          <div className="flex h-full w-full items-center justify-center bg-black/5 dark:bg-white/5">
            {props.thumbnail ? (
              <img src={props.thumbnail} className="h-full w-full object-contain" />
            ) : (
              <ImFileVideo className="text-4xl" />
            )}
          </div>
        </VideoPreview>
          : <ReactPlayer
            ref={ref}
            onPause={() => {
              setMusicVolume(1)
              props.onPause?.()
            }}
            onPlay={() => {
              setMusicVolume(0)
              props.onPlay?.()
            }}
            onStart={() => {
              setMusicVolume(0)
              props.onStart?.()
            }}
            stopOnUnmount
            className='react-player'
            width='100%'
            height='100%'
            url={url}
            pip={pip}
            playing={playing}
            controls={controls}
            loop={loop}
            volume={volume}
            muted={_muted}
            {...props}
            id="player-video"
            onError={(...args) => {
              props.onError?.(...args)
            }}
            onEnded={() => {
              onVideoEndedRef.current?.()
              setMusicVolume(1)
              props.onEnded?.()
            }}
            onReady={(p) => {
              setIsLoading(false)
              setMusicVolume(0)
              props.onReady?.(p)
            }}
          />
      }
    </div>
  </div>
};

export default VideoPlayer;
